import React from 'react';
import Commonfooter from '../../UI/FooterCommon/Commonfooter'

import footerStyle from './Footer.css';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Footer section for recruiter
* @version 1.0.1
* @author Amrutha, Praveen George
*/

const Footer= () =>{
    return (     
      <div className="rec-footer-main">
        <div className="rec-footer-text">
          <Commonfooter />
        </div>
      </div>
    );
  }


export default Footer;



// WEBPACK FOOTER //
// ./src/components/Recruiter/Footer/Footer.js